export const QUERY_PARAMS = {
    IS_DATE_NOW: 'isDateNow',
    FOR_APPROVAL: 'needsApproval',
    TRIP_ID: 'tripId',
    ID: 'id',
    CLIENT_ID: 'clientId',
    CONTAINER_ID: 'containerId',
}


// WEBPACK FOOTER //
// ./src/app/contants/QUERY_PARAMS.ts